import React from "react";

const SurveyBanner = () => {

    return (
        <aside
            role="banner"
            aria-label="Survey submission announcement"
            className="pt-6 px-6"
        >
            <div className="flex items-center bg-red-50 pl-4 pr-6 py-3 md:py-4 relative rounded-xl  mx-auto">
                <span className="text-sm text-red-700">
                    <span className="font-semibold">Note</span> · You can submit this feedback on behalf of the client.
                </span>
            </div>
        </aside>
    );
};

export default SurveyBanner;
